import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';
import { formatDate, __ } from '../../Utils';
import Icon from 'oxyrion-ui/lib/Icon';
import { AnimatedFormMessageWrapper } from '../ReusableComponents';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%
    ${({ theme }) => theme.media.m`
  width: ${rem(500)};
`};
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background: #f7f7f7;
  border-radius: 4px;
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  margin-right: ${rem(16)};
  // border: 1px solid #f7f7f7;
`;

const LinkWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%
    ${({ theme }) => theme.media.m`
  width: ${rem(500)};
`};
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background: #f7f7f7;
  border-radius: 4px;
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  margin-right: ${rem(16)};
  // border: 1px solid #f7f7f7;
  text-decoration: none;
  color: black;
`;

const Title = styled.div`
  color: ${props => props.color && props.color};
  font-size: ${rem(16)};
  margin: ${rem(4)};
  font-weight: 700;
  z-index: 2;
  &:hover {
    text-decoration: underline;
  }
`;

const ValidTo = styled.div`
  font-size: 12px;
  color: #70ae04;
  display: flex;
  margin-left: 4px;
`;

const ContentWrapper = styled.div`
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #70ae04;
  font-weight: bold;
  font-size: ${rem(16)};
`;

const Voucher = styled.div`
  padding: ${rem(6)};
  padding-left: ${rem(12)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  border: ${rem(1)} solid;
  width: ${rem(200)};
  border-radius: ${rem(6)};
  height: ${rem(38)};
`;

const Label = styled.div`
  position: absolute;
  top: -14px;
  left: 6px;
  font-size: 0.75rem;
  background: #f7f7f7;
  padding: 4px;
`;

const IconWrapper = styled.div`
  margin-left: ${rem(4)};
  margin-top: ${rem(4)};
  height: ${rem(32)};
  width: ${rem(32)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 4px;
`;

const VoucherInfo = styled.div`
  color: green;
  background: #bade7a;
  padding: 4px;
  position: absolute;
  right: 0px;
`;

const HolderEmpty = styled.div`
  transition: opacity 0.5s, height 1s;
`;

class CampaignCard extends React.Component {
  state = {
    voucherCopied: false,
  };

  render() {
    const { data } = this.props;

    if (data.campaign_alternative === 'M') {
      return (
        <CopyToClipboard text={data.voucher ? data.voucher.voucher : ''}>
          <Wrapper
            onClick={() =>
              this.setState(
                {
                  voucherCopied: true,
                },
                () =>
                  setTimeout(
                    () =>
                      this.setState({
                        voucherCopied: false,
                      }),
                    1500,
                  ),
              )
            }
          >
            <AnimatedFormMessageWrapper display={this.state.voucherCopied}>
              <VoucherInfo>{__('Kupón skopírovaný')}</VoucherInfo>
            </AnimatedFormMessageWrapper>
            {/* {!this.state.voucherCopied && <HolderEmpty />} */}
            <HolderEmpty>
              <Title>{data.name}</Title>
              <ValidTo>
                {`${__('Platí do')} ${formatDate(moment(data.valid_to))}`}
              </ValidTo>
              <ContentWrapper>
                <Voucher
                  onMouseEnter={() =>
                    this.setState({
                      isHovering: true,
                    })
                  }
                  onMouseLeave={() =>
                    this.setState({
                      isHovering: false,
                    })
                  }
                >
                  <Label>{__('Zľavový kupón')}</Label>
                  {` ${data.voucher && data.voucher.voucher}`}
                  <IconWrapper>
                    {this.state.isHovering && (
                      <Icon name="copy" size="l" color="#70ae04" />
                    )}
                  </IconWrapper>
                </Voucher>
              </ContentWrapper>
            </HolderEmpty>
          </Wrapper>
        </CopyToClipboard>
      );
    }

    return (
      <LinkWrapper to={`/buy/products?campaign=${data._id}`}>
        <Title>{data.name}</Title>
        <ValidTo>
          {`${__('Platí do')} ${formatDate(moment(data.valid_to))}`}
        </ValidTo>
        <ContentWrapper>{__('Prejsť na produkty')}</ContentWrapper>
      </LinkWrapper>
    );
  }
}

CampaignCard.propTypes = {
  data: PropTypes.shape({}),
};

CampaignCard.defaultProps = {
  data: {},
};

export default CampaignCard;



// WEBPACK FOOTER //
// ./src/Components/CampaignCard/index.jsx